import { CacheState } from './computeCacheStateForScripts'

export const deriveCacheState = (total: number, fetchedCount: number): CacheState => {
  if (fetchedCount === total) {
    return 'cold'
  } else if (fetchedCount === 0) {
    return 'warm'
  } else {
    return 'mixed'
  }
}
